var _rect, _mask, _rect2, _mask2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _ellipse, _path2, _path3, _path4, _path5, _rect13, _path6, _path7, _rect14, _rect15, _rect16, _circle, _rect17, _rect18, _rect19, _circle2, _rect20, _rect21, _rect22, _circle3, _rect23, _rect24, _rect25, _circle4, _rect26, _path8, _rect27, _rect28, _rect29, _circle5, _rect30, _rect31, _rect32, _circle6, _rect33, _rect34, _rect35, _rect36, _rect37, _ellipse2, _path9, _path10, _path11, _path12, _rect38, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingImage4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 368 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 276,
    rx: 8,
    fill: "#2D81F7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 368,
    height: 276
  }, /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 276,
    rx: 8,
    fill: "#70AAFC"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 276,
    fill: "#FFC370"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 368,
    height: 277
  }, /*#__PURE__*/React.createElement("rect", {
    y: 11.5,
    width: 368,
    height: 276,
    fill: "#1BD697"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.9977 57.1348C75.9977 52.9121 79.4209 49.4889 83.6436 49.4889H379.52C383.743 49.4889 387.166 52.9121 387.166 57.1348V279.466H75.9977V57.1348Z",
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 0.708359
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 117.092,
    width: 151.591,
    height: 3.13636,
    fill: "#F6F8FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 122.318,
    width: 118.136,
    height: 3.13636,
    fill: "#F6F8FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 131.727,
    width: 30.3182,
    height: 2.09091,
    fill: "#EBEDEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 145.318,
    width: 19.8636,
    height: 4.18182,
    fill: "#EBEDEE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 113.954,
    y: 172.5,
    width: 30.3182,
    height: 4.18182,
    fill: "#EBEDEE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 113.954,
    y: 178.773,
    width: 19.8636,
    height: 2.09091,
    fill: "#EBEDEE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 113.954,
    y: 203.865,
    width: 30.3182,
    height: 4.18182,
    fill: "#EBEDEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 113.954,
    y: 210.135,
    width: 19.8636,
    height: 2.09091,
    fill: "#EBEDEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 106.635,
    width: 34.5,
    height: 4.18182,
    fill: "#D5E6FD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 100.363,
    y: 106.635,
    width: 75.2727,
    height: 42.3409,
    rx: 3.6,
    fill: "#FFA1A1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.996,
    cy: 119.809,
    rx: 7.58596,
    ry: 7.52727,
    fill: "#FFA1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.994 129.217C126.388 129.217 116.812 137.837 115.412 148.976H160.576C159.176 137.837 149.599 129.217 137.994 129.217Z",
    fill: "#FFA1A1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.729 140.862C142.906 141.943 143.88 142.769 145.055 142.769C146.219 142.769 147.185 141.959 147.377 140.895C147.401 140.795 147.411 140.715 147.408 140.647C147.408 140.569 147.35 140.508 147.269 140.508H147.137H142.996H142.844C142.763 140.508 142.705 140.569 142.705 140.647C142.704 140.647 142.704 140.647 142.704 140.647C142.704 140.649 142.704 140.65 142.704 140.652C142.702 140.712 142.71 140.78 142.729 140.862L142.729 140.862Z",
    fill: "#FFA1A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.211 144.153C146.123 143.613 145.636 143.2 145.048 143.2C144.466 143.2 143.983 143.604 143.887 144.136C143.875 144.186 143.87 144.226 143.872 144.261C143.872 144.3 143.901 144.33 143.941 144.33H144.007H146.078H146.154C146.194 144.33 146.223 144.3 146.223 144.261C146.223 144.261 146.224 144.261 146.224 144.261C146.224 144.26 146.224 144.259 146.223 144.258C146.225 144.228 146.221 144.194 146.211 144.153Z",
    fill: "#FFA1A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9977 57.1348C75.9977 52.9121 79.4209 49.4889 83.6436 49.4889H379.854C384.077 49.4889 387.5 52.9121 387.5 57.1348V85.2964H75.9977V57.1348Z",
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 0.708359
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 348.188,
    y: 58.7656,
    width: 17.2579,
    height: 17.2579,
    rx: 2.54094,
    stroke: "#F0F4F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6402 63.0147C98.1905 66.3688 101.215 68.9339 104.864 68.9339C108.477 68.9339 111.477 66.4204 112.071 63.1163C112.147 62.8061 112.179 62.5583 112.169 62.3461C112.169 62.1029 111.988 61.9141 111.736 61.9141H111.328H98.4699H97.9993C97.7478 61.9141 97.5664 62.1026 97.5661 62.3455C97.5656 62.3455 97.565 62.3455 97.5645 62.3454C97.5648 62.3509 97.5651 62.3563 97.5655 62.3617C97.5589 62.5466 97.5831 62.7585 97.6402 63.0147H97.6402Z",
    fill: "#2D81F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.452 73.2368C108.177 71.5597 106.665 70.2772 104.84 70.2772C103.034 70.2772 101.534 71.5339 101.237 73.186C101.199 73.3411 101.183 73.465 101.188 73.5711C101.188 73.6927 101.279 73.7871 101.405 73.7871H101.609H108.038H108.273C108.399 73.7871 108.489 73.6929 108.489 73.5714C108.49 73.5714 108.49 73.5714 108.49 73.5714C108.49 73.5687 108.49 73.566 108.49 73.5633C108.493 73.4708 108.481 73.3649 108.452 73.2368Z",
    fill: "#08BD80"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 172.5,
    width: 166.227,
    height: 18.8182,
    fill: "#F6F8FA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 203.863,
    y: 178.773,
    width: 30.3182,
    height: 2.09091,
    fill: "#E4E4E4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 203.863,
    y: 182.957,
    width: 46,
    height: 3.13636,
    fill: "#E4E4E4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193.41,
    cy: 181.909,
    r: 5.22727,
    fill: "#EB5757"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 203.865,
    width: 166.227,
    height: 18.8182,
    fill: "#F6F8FA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 203.863,
    y: 210.135,
    width: 30.3182,
    height: 2.09091,
    fill: "#E4E4E4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 203.863,
    y: 214.318,
    width: 46,
    height: 3.13636,
    fill: "#E4E4E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.41,
    cy: 213.27,
    r: 5.22727,
    fill: "#08BD80"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 226.865,
    width: 166.227,
    height: 18.8182,
    fill: "#F6F8FA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 203.863,
    y: 233.135,
    width: 30.3182,
    height: 2.09091,
    fill: "#E4E4E4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 203.863,
    y: 237.318,
    width: 46,
    height: 3.13636,
    fill: "#E4E4E4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.41,
    cy: 236.27,
    r: 5.22727,
    fill: "#08BD80"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 249.865,
    width: 166.227,
    height: 18.8182,
    fill: "#F6F8FA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 203.863,
    y: 256.135,
    width: 30.3182,
    height: 2.09091,
    fill: "#E4E4E4"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 203.863,
    y: 260.318,
    width: 46,
    height: 3.13636,
    fill: "#E4E4E4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.41,
    cy: 259.27,
    r: 5.22727,
    fill: "#08BD80"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 272.865,
    width: 166.227,
    height: 18.8182,
    fill: "#F6F8FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0827 125.297C17.0827 121.074 20.5058 117.651 24.7285 117.651H101.147C105.369 117.651 108.793 121.074 108.793 125.297V279.83H17.0827V125.297Z",
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 0.708359
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0908,
    y: 237.318,
    width: 75.2727,
    height: 18.8182,
    fill: "#F6F8FA"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9541,
    y: 243.592,
    width: 30.3182,
    height: 2.09091,
    fill: "#E4E4E4"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9541,
    y: 247.773,
    width: 46,
    height: 3.13636,
    fill: "#E4E4E4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.4988,
    cy: 246.727,
    r: 5.22727,
    fill: "#EB5757"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0908,
    y: 264.5,
    width: 75.2727,
    height: 18.8182,
    fill: "#F6F8FA"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9541,
    y: 270.773,
    width: 30.3182,
    height: 2.09091,
    fill: "#E4E4E4"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9541,
    y: 274.957,
    width: 46,
    height: 3.13636,
    fill: "#E4E4E4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.4988,
    cy: 273.909,
    r: 5.22727,
    fill: "#08BD80"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0908,
    y: 212.227,
    width: 66.9091,
    height: 3.13636,
    fill: "#F6F8FA"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0908,
    y: 217.457,
    width: 52.2727,
    height: 3.13636,
    fill: "#F6F8FA"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0908,
    y: 226.865,
    width: 30.3182,
    height: 2.09091,
    fill: "#EBEDEE"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0908,
    y: 201.773,
    width: 34.5,
    height: 4.18182,
    fill: "#D5E6FD"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0908,
    y: 150.543,
    width: 75.2727,
    height: 42.3409,
    rx: 3.6,
    fill: "#1BD697"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.7237,
    cy: 163.717,
    rx: 7.58596,
    ry: 7.52727,
    fill: "#1BD697"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7215 173.125C51.116 173.125 41.5395 181.745 40.1396 192.884H85.3033C83.9034 181.745 74.3269 173.125 62.7215 173.125Z",
    fill: "#1BD697"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.457 184.772C67.6343 185.853 68.6085 186.679 69.7839 186.679C70.9473 186.679 71.9137 185.869 72.1051 184.805C72.1296 184.705 72.1397 184.625 72.1366 184.557C72.1366 184.479 72.0782 184.418 71.9971 184.418H71.8656H67.7242H67.5727C67.4917 184.418 67.4332 184.479 67.4332 184.557C67.433 184.557 67.4328 184.557 67.4326 184.557C67.4327 184.559 67.4328 184.56 67.433 184.562C67.4308 184.622 67.4386 184.69 67.457 184.772L67.457 184.772Z",
    fill: "#1BD697"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.937 188.065C70.8484 187.525 70.3613 187.112 69.7736 187.112C69.1919 187.112 68.7087 187.516 68.613 188.049C68.6007 188.099 68.5957 188.138 68.5972 188.173C68.5972 188.212 68.6264 188.242 68.667 188.242H68.7327H70.8034H70.8792C70.9197 188.242 70.9489 188.212 70.9489 188.173C70.949 188.173 70.9491 188.173 70.9492 188.173C70.9492 188.172 70.9491 188.171 70.949 188.17C70.9501 188.14 70.9462 188.106 70.937 188.065Z",
    fill: "#1BD697"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0827 125.297C17.0827 121.074 20.5058 117.651 24.7285 117.651H101.147C105.369 117.651 108.793 121.074 108.793 125.297V141.202H17.0827V125.297Z",
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 0.708359
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3164,
    y: 124.729,
    width: 9.39705,
    height: 9.39705,
    rx: 2.54094,
    stroke: "#F0F4F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8584 126.612C25.1849 128.601 26.9791 130.123 29.1437 130.123C31.2863 130.123 33.0662 128.632 33.4186 126.672C33.4637 126.488 33.4824 126.341 33.4767 126.215C33.4767 126.071 33.369 125.959 33.2197 125.959H32.9776H25.3506H25.0714C24.9223 125.959 24.8146 126.071 24.8145 126.215C24.8141 126.215 24.8138 126.215 24.8135 126.215C24.8137 126.218 24.8139 126.221 24.8141 126.225C24.8102 126.334 24.8245 126.46 24.8584 126.612L24.8584 126.612Z",
    fill: "#2D81F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2715 132.674C31.1083 131.679 30.2111 130.918 29.1288 130.918C28.0575 130.918 27.1676 131.663 26.9914 132.643C26.9688 132.735 26.9595 132.809 26.9623 132.872C26.9623 132.944 27.0162 133 27.0908 133H27.2119H31.0254H31.165C31.2396 133 31.2934 132.944 31.2934 132.872C31.2936 132.872 31.2938 132.872 31.2939 132.872C31.2938 132.87 31.2937 132.869 31.2936 132.867C31.2956 132.812 31.2884 132.75 31.2715 132.674Z",
    fill: "#08BD80"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingImage4);
export default __webpack_public_path__ + "static/media/landing_image_4.7b2bd02ee9bebe528b479995f43a26a3.svg";
export { ForwardRef as ReactComponent };